export class DivisionWiseRevenueDetailsResp {
    category_name: string;
    tdy_budget: string;
    tdy_actual_revenue: string;
    mtd_actual: string;
    ytd_actual: string;
    divisionCode?:string;
    mtd_budget: string;
    mtd_last_year:string;
    ytd_budget:string;
    ytd_last_year: string;
    tdy_last_year_revenue: string;
}